import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgotPassword/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Toast
import toastReducer from "./toast/reducer";

// Dashboard
import DashboardReducer from "./analytics/reducer";

// Users
import UsersReducer from "./users/reducer";

// Analytics
import AnalyticsReducer from "./analytics/reducer";

// News
import NewsReducer from "./news/reducer";

//Posts
import PostsReducer from "./Posts/reducer";

// Chats
import ChatReducer from "./chat/reducer";
// Policy & Terms
import PolicyTermsReducer from "./policyTerms/reducer";

import ContactReducer from "./contectUs/reducer";

import SubscriptionReducer from "./subscription/reducer";

import setNotifications from "./notification/reducer";

// Drawings History
import DrawingsHistoryReducer from "./drawingsHistory/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  toast: toastReducer,
  Dashboard: DashboardReducer,
  Users: UsersReducer,
  Analytics: AnalyticsReducer,
  News: NewsReducer,
  Posts: PostsReducer,
  Chat: ChatReducer,
  policyTerms: PolicyTermsReducer,
  Contact: ContactReducer,
  Subscription: SubscriptionReducer,
  Notification: setNotifications,
  DrawingsHistory: DrawingsHistoryReducer,
});

export default rootReducer;
